import { DEFAULT_AUTHOR, PUBLISHER, SITE_URL, DEFAULT_OG_IMAGE } from "@/lib/site";

export interface ArticleSchemaInput {
  title: string;
  description: string;
  path: string;
  datePublished: string;
  dateModified: string;
  image?: string;
  author?: { "@type": string; name: string; url?: string };
}

export function articleSchema(input: ArticleSchemaInput) {
  const url = `${SITE_URL}${input.path}`;
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: input.title,
    description: input.description,
    image: input.image ?? DEFAULT_OG_IMAGE,
    datePublished: input.datePublished,
    dateModified: input.dateModified,
    author: input.author ?? DEFAULT_AUTHOR,
    publisher: PUBLISHER,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
    url,
  };
}

export interface BreadcrumbItem {
  name: string;
  path: string;
}

export function breadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export interface ItemListEntry {
  name: string;
  url: string;
  description?: string;
}

export function itemListSchema(items: ItemListEntry[], aboutPath: string) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    url: `${SITE_URL}${aboutPath}`,
    numberOfItems: items.length,
    itemListOrder: "https://schema.org/ItemListUnordered",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      url: item.url,
      ...(item.description ? { description: item.description } : {}),
    })),
  };
}

export function webPageSchema(title: string, description: string, path: string) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description,
    url: `${SITE_URL}${path}`,
    publisher: PUBLISHER,
  };
}

export function aboutPageSchema(
  title: string,
  description: string,
  path: string,
  parent: { name: string; url: string },
) {
  return {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: title,
    description,
    url: `${SITE_URL}${path}`,
    publisher: {
      ...PUBLISHER,
      parentOrganization: {
        "@type": "Organization",
        name: parent.name,
        url: parent.url,
      },
    },
  };
}
